// import React from "react";
// import intersect from "../assets/Intersect.png";
// import p1 from "../assets/p1.png";
// import p2 from "../assets/p2.png";
// import p3 from "../assets/p3.png";
// import PhoneHeader from "./PhoneHeader";

// const HeroSection = () => {
//   return (
//     <>
//       <section className="container space hero-section responsive-padding responsives">
//         <div className="row align-items-center">
//           <div className="col-lg-6 col-md-6 mb-5 mb-md-0 px-lg-3 px-3 text-center text-md-start">
//             <div className="hero-text">
//               <PhoneHeader className="back" />

//               <div className="col-12 col-md-12 d-flex text-justify ">
//                 <div className="text-center p-4">
//                   <span className="hero-tag d-inline-block mb-3">
//                     AEPS PAY PAYMENT
//                   </span>
//                   <h1 className="fw-bold mb-3 hero-heading">
//                     AEPSPay – Fast, Secure <br className="d-none d-md-block" />&
//                     Convenient Banking at Your Fingertips
//                   </h1>
//                   <p className="text-secondary mb-4 hero-subtext">
//                     Withdraw, Deposit & Check Balance Instantly – Anytime,
//                     Anywhere.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="col-lg-6 col-md-6 position-relative text-center mt-4 mt-md-0">
//             <div className="hero-circle">
//               <img
//                 src={intersect}
//                 className="img-fluid hero-main-img"
//                 alt="main"
//               />

//               <div className="hero-card card1">
//                 <img src={p1} alt="" />
//                 <p className="mb-0 text-start">
//                   Cash <br /> Withdrawal
//                 </p>
//               </div>

//               <div className="hero-card card2">
//                 <img src={p2} alt="" />
//                 <p className="mb-0">Cash Deposit</p>
//               </div>

//               <div className="hero-card card3">
//                 <img src={p3} alt="" />
//                 <p className="mb-0">Balance Enquiry</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default HeroSection;

import React from 'react'
import intersect from "../assets/Intersect.png";
import p1 from "../assets/cash-withdrawal-icon.svg";
import p2 from "../assets/deposit-icon.svg";
import p3 from "../assets/inquery-icon.svg";
import PhoneHeader from "./PhoneHeader";

const HeroSection = () => {
  return (
    <div className="herosection">
       <section className="hero">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-6 hero-content text-center text-xl-start pb-4 pb-md-5 pb-xl-0">

              <PhoneHeader className="back" />

              <span>AEPS PAY PAYMENT</span>
              <h1 className="fw-bold my-3">
                AEPSPay – Fast, Secure <br /> Convenient Banking  <br /> at Your Fingertips
              </h1>
              <h5>
                Withdraw, Deposit & Check Balance Instantly – Anytime, Anywhere.
              </h5>
            </div>
            <div className="col-xl-6 d-flex justify-content-xl-end justify-content-center">
              <div className="hero-img position-relative pe-4">
                <figure className="m-0">
                  {" "}
                  <img src={intersect} alt="hero" />{" "}
                </figure>
                <ul className="m-0 p-0">
                  <li className="d-flex align-items-center gap-3 bg-white shadow-sm px-3 py-2 position-absolute">
                    <img src={p1} alt="" />
                    <h6 className="mb-0">
                      Cash
                      <br /> Withdrawal
                    </h6>
                  </li>
                  <li className="d-flex align-items-center gap-3 bg-white shadow-sm px-3 py-2 position-absolute">
                    <img src={p2} alt="" />
                    <h6 className="mb-0">
                      Balance <br /> Enquiry
                    </h6>
                  </li>
                  <li className="d-flex align-items-center gap-3 bg-white shadow-sm px-3 py-2 position-absolute">
                    <img src={p3} alt="" />
                    <h6 className="mb-0">
                      Cash <br /> Deposit
                    </h6>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default HeroSection